module.exports = __webpack_public_path__ + "media/images/FFE-940-d3bb05d383b82d7e02ad5bc4ea2fb69a.png";